module.exports = __webpack_public_path__ + "static/media/ingve.362ec382.JPG";